"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientConfigurationFragmentDependencies = exports.clientConfigurationFragment = void 0;
exports.clientConfigurationFragment = `
fragment clientConfigurationFragment on ClientConfiguration {
  supportedSmsCountryCodes
  supportedTargetTypes
}
`.trim();
exports.clientConfigurationFragmentDependencies = [];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpZW50Q29uZmlndXJhdGlvbkZyYWdtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL2ZyYWdtZW50cy9jbGllbnRDb25maWd1cmF0aW9uRnJhZ21lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwyQkFBMkIsR0FBRzs7Ozs7Q0FLMUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVJLFFBQUEsdUNBQXVDLEdBQUcsRUFBRSxDQUFDIn0=